import {
  TextField,
  Stack,
  Checkbox,
} from "@mui/material";
import UserCheckboxList from "./UserCheckboxList";
import { axiosInstance } from "../utility/apiInstance";
import React from "react";
import toast from "react-hot-toast";

interface TeamFormProps {
  userId: any;
  CustomerList: any;
  onClose: () => void;
}

const TeamForm = ({ userId, CustomerList, onClose }: TeamFormProps) => {
  const [description, setDescription] = React.useState<any>(null);
  const [selectAllteamMembers, setSelectAllteamMembers] = React.useState<boolean>(false);
  const [teamName, setTeamName] = React.useState<any>(null);
  const [teamLeaders, setTeamLeaders] = React.useState<any[]>([]);
  const [teamMembers, setTeamMembers] = React.useState<any[]>([]);
  // const [CustomerList, setAllCustomer] = React.useState<any>();


  const resetTeamFrom = () => {
    setDescription(null);
    setTeamMembers([])
    setTeamLeaders([])
    setTeamName(null)
  }


  const createNewTeam = async () => {
    if (!teamName) {
      return toast.error("Team Name is Required");
    }
    if (teamMembers?.length == 0) {
      return toast.error("Team Members are Required");
    }
    if (!Array.isArray(teamLeaders) || teamLeaders.length === 0) {
      return toast.error("Team Leaders are Required");
    }
    const filteredIds = new Set(
  filteredTeamMembers.map((member : any) => member._id)
);

const validTeamMembers = teamMembers.filter(id =>
  filteredIds.has(id)
)
 if (validTeamMembers?.length == 0) {
      return toast.error("Team Members are Required");
    }
    try {
      const formData = {
        teamName: teamName,
        description: description,
        teamMembers: validTeamMembers,
        teamLeaders: teamLeaders,
      };

      const response = await axiosInstance.post(
        "/api/v1/customer-team", formData)
      if (response?.data?.success == true) {
        const Message = response?.data?.message || "A New Team Created"
        toast.success(Message)
        onClose();
        resetTeamFrom()
      }
    } catch (error: any) {
      toast.error("Unable to Create Team")
      console.error("Error to Create Team", error)
    }
  }


  const updateATeam = async () => {
    if (!teamName) {
      toast.error("Team Name is Required");
      return;
    }
   
    if (teamMembers?.length == 0) {
      toast.error("Team Members are Required");
      return;
    }
    if (teamLeaders?.length == 0) {
      toast.error("Team Leaders are Required");
      return;
    }
    if (!userId) {
      toast.error("User ID is Required");
      return;
    }

        const filteredIds = new Set(
  filteredTeamMembers.map((member : any) => member._id)
);

const validTeamMembers = teamMembers.filter(id =>
  filteredIds.has(id)
)
 if (validTeamMembers?.length == 0) {
      return toast.error("Team Members are Required");
    }
    try {
      const formData = {
        teamName: teamName,
        description: description,
        teamMembers: validTeamMembers,
        teamLeaders: teamLeaders,

      };
      if (userId) {
        const response = await axiosInstance.put(`/api/v1/customer-team/${userId}`, formData);

        if (response?.data?.success == true) {
          const Message = response?.data?.message || "Team Successfully Updated"
          toast.success(Message)
          // resetTeamFrom();
          onClose();
        }
      }
    } catch (error) {
      console.error("error in Update Cusotomer", error);
      toast.error("Unable to Update Team")
    }
  }



  const FetchATeam = async () => {
    try {
      if (userId) {
        const response = await axiosInstance.get(
          `/api/v1/customer-team/${userId}`,
        );

        const res = response?.data?.data
        setTeamName(res?.teamName);
        setDescription(res?.description)
        setTeamMembers(res?.teamMembers);
        setTeamLeaders(res?.teamLeaders);
      }
    } catch (error: any) {
      console.error("Error in Get a Team info ", error)
    }
  }



  React.useEffect(() => {
    if (!userId) return
    FetchATeam();
  }, [userId]);


  const onHandleSave = () => {
    if (userId) {
      updateATeam()
    } else {
      createNewTeam();
    }
    

  }
  const filteredTeamMembers = CustomerList.filter(
    (user: any) => !teamLeaders.includes(user._id)
  );

 
  const handleAllSelect = (users: any, checked: boolean) => {
    if (checked) {
      const usersIds = users?.map((i: any) => i._id)
      setTeamMembers(usersIds);
      setSelectAllteamMembers(checked)

    } else {
      setSelectAllteamMembers(checked)
      setTeamMembers([])
    }
  }

  return (
    <Stack spacing={2}>
      <div className="formTeam">
          {/* Team Name */}
          <div className="form-group">
            <label className="control-label">Team Name {" "} <span className="text-red-500 font-semibold">*</span></label>
            <TextField
              fullWidth
              placeholder = "Enter Team Name"
              value={teamName}
              onChange={(e) => { setTeamName(e.target.value) }}
              size="small"
            // defaultValue="Global Logistics"
            />
          </div>

          {/* Description */}
          <div className="form-group">
            <label className="control-label">Description</label>
            <TextField
              fullWidth
              placeholder= "Enter Description"
              size="small"
              value={description}
              onChange={(e) => { setDescription(e.target.value) }}
              multiline
              minRows={3}
            // defaultValue="This team has been created for Global Logistics department"
            />
          </div>

          {/* Team Leaders */}
          <div className="form-group">
            <label className="control-label">Team Leader(s) {" "} <span className="text-red-500 font-semibold">*</span></label>
            <UserCheckboxList users={CustomerList} selectedIds={teamLeaders} setSelectedIds={setTeamLeaders} />
          </div>

          {/* Team Members */}
          <div className="form-group">
            <div className="flex justify-between">
            <label className="control-label">Team Members {" "} <span className="text-red-500 font-semibold">*</span></label>
            <Checkbox
              className="flex justify-end"
                size="small"
                // indeterminate={
                //   teamMembers?.length > 0 &&
                //   teamMembers?.length < CustomerList?.length
                // }
                // checked={selectAllteamMembers}
                checked={teamMembers.length === CustomerList.length}
                onChange={(e, checked) => {
                  handleAllSelect(CustomerList, checked)
                  // setSelectAllteamMembers(checked)

                }}
                sx={{
          color: "green",
          "&.Mui-checked": {
            color: "red",
          },
          "&.MuiCheckbox-indeterminate": {
            color: "red",
          },
              }}
            />
            </div>
            <UserCheckboxList users={filteredTeamMembers}
              selectedIds={teamMembers} setSelectedIds={setTeamMembers} />
          </div>

          {/* Actions */}
          <div className="btnTeamFooter">

            <button className="btn btnBlack" onClick={() => { onClose()
              // , resetTeamFrom() 
              }}>
              Cancel
            </button>
            <button className="btn btnYellow" onClick={() => { onHandleSave() }}>
              Save
            </button>
          </div>
      </div>
    </Stack>
  );
};

export default TeamForm;
